// extracted by mini-css-extract-plugin
export default {"itemsRow":"SVIoUq","file":"fR8nFK","itemsRowInner":"BjQGLs","relatedItem":"YFu2aV"};